type AlertType = 'alert' | 'confirm' | 'prompt';

const AlertHandler = (type: AlertType, msg: string, def?: string) => {
  const handler = window[type](msg, def);

  return handler;
};

const Alert = {
  alert: (msg: string) => AlertHandler('alert', msg),
  confirm: (msg: string) => AlertHandler('confirm', msg),
  prompt: (msg: string, defaultValue?: string) =>
    AlertHandler('prompt', msg, defaultValue),
};

export default Alert;
